import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

// @dynamic
@Injectable({
    providedIn: 'root',
})
export class ReferrerService {
    constructor(@Inject(DOCUMENT) private readonly document: Document) {}

    /**
     * Check referrer validity into domain
     * @param referrers referrers list
     * @returns boolean
     */
    public isReferrerValid(referrers: string[]): boolean {
        const domain = this._getReferrerDomain();
        if ((referrers && !domain) || (referrers && domain && !referrers.some((r) => domain.includes(r)))) {
            return false;
        }

        return true;
    }

    /**
     * Extract domain from referrer
     * @param referrer referrer
     * @returns string
     */
    private _getReferrerDomain(): string {
        const url = this.document.referrer ? new URL(this.document.referrer) : null;
        return url?.hostname || null;
    }
}
